module.exports = __webpack_public_path__ + "img/isayinput_web.96d2c2bb.png";